import styled, { css } from 'styled-components';
import { Typography } from '../../global/theme';
import { mobile_xl } from '../../global/mediaQueryMixin';
import { AlignCenter, FlexBetween, HideScrollbar, ShowVerticalScrollbar } from '../../global/commonStyle';

const TaskTemplateHeader = styled.div`
  ${FlexBetween}
  padding-block: var(--space-14);
`;
const HeaderText = styled.div`
  ${Typography.heading_lg}
  color: var(--text-primary);
`;
const Group = styled.form`
  max-width: 662px;
  width: 100%;
  margin: var(--space-0) auto;
`;
const BottomSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--space-12);
  ${mobile_xl(css`
    margin-top: var(--space-8);
  `)}
`;

const Inputs = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: var(--space-16);
  padding: var(--space-16);
  background: var(--background-primary);
  border: 0.5px solid var(--border-primary);
  border-radius: var(--border-radius-8);
  ${mobile_xl(css`
    gap: var(--space-12);
  `)}
`;
const TextField = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--space-10);
  width: 100%;
`;

const Textarea = styled.textarea`
  ${Typography.heading_lg}
  color: var(--text-primary);
  margin: var(--space-0);
  border: none;
  padding: var(--space-0);
  font-family: unset;
  background: var(--background-primary);
  min-height: 22px;
  max-height: 66px;
  resize: none;
  ${HideScrollbar}
  ::placeholder {
    ${Typography.heading_lg}
    color: var(--text-primary);
  }
  &:focus {
    outline: none;
  }
  a {
    color: var(--text-link);
    text-decoration: underline;
  }
`;
const DescriptionSection = styled.div`
  .tiptap {
    max-height: 240px;
    ${ShowVerticalScrollbar}
  }
  p {
    margin: var(--space-0);
    ${Typography.body_md_medium}
  }
  > div > div > div {
    ${HideScrollbar}
  }
  .ProseMirror {
    min-height: 90px;
  }
`;
const Buttons = styled.div`
  display: flex;
  justify-content: space-between;
  gap: var(--space-10);
  width: 100%;
  ${mobile_xl(css`
    align-items: flex-end;
  `)}
`;
const Leftbuttons = styled.div`
  display: flex;
  gap: var(--space-8);
  ${mobile_xl(css`
    flex-direction: column;
  `)}
`;

const UploadDiv = styled.div`
  padding-inline: var(--space-16);
  color: var(--text-primary);
`;
const Detail = styled.div`
  cursor: pointer;
  display: flex;
`;
const OverLayDiv = styled.div`
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
`;

const HeaderTitle = styled.div`
  ${mobile_xl(css`
    ${AlignCenter}
    gap: var(--space-24);
  `)}
`;
export {
  TaskTemplateHeader,
  HeaderText,
  Group,
  BottomSection,
  Inputs,
  Textarea,
  TextField,
  DescriptionSection,
  Buttons,
  Leftbuttons,
  UploadDiv,
  Detail,
  OverLayDiv,
  HeaderTitle
};
